var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDServices(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3,
    width: 9,
    height: 9,
    rx: 2,
    stroke: "#5F5B5B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6L16.5 6",
    stroke: "#5F5B5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9H4L10.2622 11.7397C11.2241 12.1605 11.6664 13.2784 11.2528 14.2434V14.2434C10.837 15.2136 9.71355 15.663 8.74342 15.2472L7 14.5",
    stroke: "#5F5B5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33541 17.3292C1.96493 17.1439 1.51442 17.2941 1.32918 17.6646C1.14394 18.0351 1.29411 18.4856 1.66459 18.6708L2.33541 17.3292ZM11.3354 14.3292L10.6646 13.9938L9.99377 15.3354L10.6646 15.6708L11.3354 14.3292ZM13.7331 16.3666L13.3977 17.0374L13.7331 16.3666ZM16.4164 17.75H18V16.25H16.4164V17.75ZM18 20.25H9.88854V21.75H18V20.25ZM6.64625 19.4846L2.33541 17.3292L1.66459 18.6708L5.97542 20.8262L6.64625 19.4846ZM14.0685 15.6957L11.3354 14.3292L10.6646 15.6708L13.3977 17.0374L14.0685 15.6957ZM9.88854 20.25C8.76302 20.25 7.65295 19.9879 6.64625 19.4846L5.97542 20.8262C7.19041 21.4337 8.53015 21.75 9.88854 21.75V20.25ZM19.25 19C19.25 19.6904 18.6904 20.25 18 20.25V21.75C19.5188 21.75 20.75 20.5188 20.75 19H19.25ZM18 17.75C18.6904 17.75 19.25 18.3096 19.25 19H20.75C20.75 17.4812 19.5188 16.25 18 16.25V17.75ZM16.4164 16.25C15.6014 16.25 14.7975 16.0602 14.0685 15.6957L13.3977 17.0374C14.335 17.506 15.3685 17.75 16.4164 17.75V16.25Z",
    fill: "#5F5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDServices);
export default __webpack_public_path__ + "static/media/d-services.3e8bf31645d76acb940a472163388f93.svg";
export { ForwardRef as ReactComponent };